var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleFiledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.291016 6.49979C0.291016 3.43915 2.77216 0.958008 5.8328 0.958008H12.1663C15.2269 0.958008 17.7081 3.43915 17.7081 6.49979C17.7081 9.56044 15.2269 12.0416 12.1663 12.0416H5.8328C2.77216 12.0416 0.291016 9.56044 0.291016 6.49979ZM9.29642 6.49979C9.29642 4.91482 10.5813 3.62994 12.1663 3.62994C13.7512 3.62994 15.0361 4.91482 15.0361 6.49979C15.0361 8.08475 13.7512 9.36965 12.1663 9.36965C10.5813 9.36965 9.29642 8.08475 9.29642 6.49979Z",
    fill: "#151918",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleFiledIcon);
export default __webpack_public_path__ + "static/media/ToggleFiledIcon.13931aa9519cb89400a1355f46ae717e.svg";
export { ForwardRef as ReactComponent };